<template>
	<u-skeleton
		class="min-h-[380px] max-w-[400px] mx-auto lg:flex-1 w-full"
		:ui="{
			rounded: 'rounded-lg',
			background: 'bg-gray-300',
			strategy: 'override'
		}"
	/>
</template>
